
import React from 'react'
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../../common/components/form/form.module'
import { format } from '../../../../../../../common/services/date.service'

export default function ShipmentBasicInfoComponent({ selectShipping, handleInnerFormChange, getTransportersName, transportAgents }: any) {
  return (
    <>
      <AccordionContainer
        child={

          <div className=' grid grid-cols-4 gap-4'>
            <InputContainer
              isDisabled
              label="Transporter"
              name="TransporterId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TransporterId'
                )
              }}
              type="text"
              value={getTransportersName(selectShipping?.TransporterId)}
            />
            <InputContainer
              isDisabled
              label="Transport Agent"
              labelField="Name"
              list={transportAgents}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'AgentId'
                )
              }}
              type="select"
              value={selectShipping?.AgentId}
              valueField="Id"
            />
            <InputContainer
              isDisabled
              label="ShipmentPId"
              name="ShipmentPId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ShipmentPId'
                )
              }}
              type="text"
              value={selectShipping?.ShipmentPId}
            />
            <InputContainer
              isDisabled
              label="Invoice Number"
              name="InvoiceNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'InvoiceNumber'
                )
              }}

              type="text"
              value={selectShipping?.InvoiceNumber}
            />
            <InputContainer
              isDisabled
              label="Tracking Number"
              name="TrackingNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TrackingNumber'
                )
              }}

              type="text"
              value={selectShipping?.TrackingNumber}
            />
            <InputContainer
              isDisabled
              label="Shipping Provider Name"
              name="ShippingProviderName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ShippingProviderName'
                )
              }}

              type="text"
              value={selectShipping?.ShippingProviderName}
            />
            <InputContainer
              isDisabled
              label="ShippedDate"
              name="ShippedDateUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ShippedDateUtc'
                )
              }}

              type="date"
              value={format(selectShipping?.ShippedDateUtc)}
            />
            <InputContainer
              isDisabled
              label="DeliveryDate"
              name="DeliveryDateUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DeliveryDateUtc'
                )
              }}

              type="date"
              value={format(selectShipping?.DeliveryDateUtc)}
            />

            <InputContainer
              isDisabled
              label="Notes"
              name="ShipmentNotes"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ShipmentNotes'
                )
              }}
              type="text"
              value={selectShipping?.ShipmentNotes}
            />
            <InputContainer
              isDisabled
              label="Delayed Pickup Time (Mins)"
              name="DelayedPickupTime"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DelayedPickupTime'
                )
              }}
              type="text"
              value={selectShipping?.DelayedPickupTime}
            />
            <InputContainer
              isDisabled
              label="Delayed Delivery Time (Mins)"
              name="DelayedDeliveryTime"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DelayedDeliveryTime'
                )
              }}
              type="text"
              value={selectShipping?.DelayedDeliveryTime}
            />
            <InputContainer
              isDisabled
              label="Waiting Charge"
              name="Price"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'WaitingCharge'
                )
              }}
              type="number"
              value={selectShipping?.WaitingCharge}
            />
            <InputContainer
              isDisabled
              label="Pickup Code"
              name="PickupCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PickupCode'
                )
              }}
              type="text"
              value={selectShipping?.PickupCode}
            />
            <InputContainer
              isDisabled
              label="Delivery Code"
              name="DeliveryCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DeliveryCode'
                )
              }}
              type="text"
              value={selectShipping?.DeliveryCode}
            />
            <InputContainer
              isDisabled
              label="Total Weight"
              name="TotalWeight"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TotalWeight'
                )
              }}
              type="text"
              value={selectShipping?.TotalWeight}
            />
            <InputContainer
              isDisabled
              label="Leave At Door"
              name="IsLeaveAtDoor"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsLeaveAtDoor'
                )
              }}
              type="checkbox"
              value={selectShipping?.IsLeaveAtDoor}
            />
            <InputContainer
              isDisabled
              label="LogisticsOrder"
              name="IsLogisticsOrder"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsLogisticsOrder'
                )
              }}
              type="checkbox"
              value={selectShipping?.IsLogisticsOrder}
            />
            <InputContainer
              isDisabled
              label="ShipmentByVendor"
              name="IsShipmentByVendor"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsShipmentByVendor'
                )
              }}
              type="checkbox"
              value={selectShipping?.IsShipmentByVendor}
            />
          </div>
        }
        expandedPanel="basicInfo"
        headerTitle="Basic Info"
      />


    </>
  )
}